module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_G.219d0db1.jpg";